import React from 'react';
import { getScoreColorClass } from 'utils/scoreColors';
import { useTranslation } from 'react-i18next';
import './TagSection.css';

const TagsSection = ({ data }) => {
  const { t } = useTranslation();
  
  const h1 = data?.h1 || { score: 0 };
  const h2 = data?.h2 || { score: 0 };
  
  const translateComposite = (text) => {
    try {
      const arrayNumbers = text.match(/\d+/g)?.map(Number) || [];
      return `${arrayNumbers[0]}${t(' balises H2 trouvées,')} ${
        arrayNumbers[2]
      }${t(' avec mot-clé.')}`;
    } catch (error) {
      return text;
    }
  };

  return (
    <div className="tags-section">
      {/* H1 Tag Section */}
      <div className="tags-subsection">
        <div className="tags-row">
          <div className="tags-title">{t('Titre H1')} :</div>
          <div
            className={`tags-score ${getScoreColorClass(h1.score)}`}
          >
            {h1.score}%
          </div>
        </div>

        {h1.message && (
          <div className="tags-message">{t(h1.message)}</div>
        )}

        {h1.recommendation && (
          <div className="ux-recommendation">
            <span className="recommendation-icon"></span>
            <div className="recommendation-content">
              <span className="recommendation-label">
                {t('Notre recommandation')} :{' '}
              </span>
              <span className="recommendation-text">
                {t(h1.recommendation)}
              </span>
            </div>
          </div>
        )}

        {h1.gratification && (
          <div className="success-message">
            <span className="emoji">🎉</span> {t(h1.gratification)}
          </div>
        )}
      </div>

      <hr className="position-divider" />

      {/* H2 Tag Section */}
      <div className="tags-subsection">
        <div className="tags-row">
          <div className="tags-title">{t('Titres H2')} :</div>
          <div
            className={`tags-score ${getScoreColorClass(h2.score)}`}
          >
            {h2.score}%
          </div>
        </div>

        {h2.message && (
          <div className="tags-message">
            {translateComposite(h2.message)}
          </div>
        )}
        {h2.recommendation && (
          <div className="ux-recommendation">
            <span className="recommendation-icon"></span>
            <div className="recommendation-content">
              <span className="recommendation-label">
                {t('Notre recommandation')} :{' '}
              </span>
              <span className="recommendation-text">
                {t(h2.recommendation)}
              </span>
            </div>
          </div>
        )}

        {h2.gratification && (
          <div className="success-message">
            <span className="emoji">🎉</span> {t(h2.gratification)}
          </div>
        )}
      </div>
    </div>
  );
};

export default TagsSection;
